module.exports = __webpack_public_path__ + "img/ic24idcode.140f97b0.svg";